import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  CampusWardsDataService,
  ConfigService,
  UserService,
  CampusUnitAccess,
  ChurchUnitsDataService,
  UnitType,
  NavigationService,
  UnitLoginResult,
} from '../../shared';
import { Route, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-unit-login',
  templateUrl: './unit-login.component.html',
  styleUrls: ['./unit-login.component.scss']
})
export class UnitLoginComponent implements OnInit {
  loading: boolean;
  validating: boolean;
  loginForm: FormGroup;
  loginInfo: CampusUnitAccess;
  errorResults = false;

  private subscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private wardService: CampusWardsDataService,
    private churchUnitsService: ChurchUnitsDataService,
    private configService: ConfigService,
    private router: Router,
    private navigationService: NavigationService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.subscription = null;
    this.navigationService.unsubscribeUser();
    this.loading = false;
    this.validating = false;
    this.loginForm = this.formBuilder.group({
      unitNum: ['', Validators.required],
      unitKey: ['', Validators.required]
    });
  }

  loginAsAdmin() {
    this.router.navigate(['/login']);
  }

  /**
   * unit login
   */
  login() {
    this.errorResults = false;
    this.validating = true;

    if (!this.loginForm.valid) {
      return;
    }

    this.loginInfo = new CampusUnitAccess();
    this.loginInfo.password = this.loginForm.get('unitKey')?.value;
    this.loginInfo.unitNumber = this.loginForm.get('unitNum')?.value;

    this.churchUnitsService.unitLogIn(this.loginInfo).subscribe(
      (result: UnitLoginResult) => {
        this.validating = false;
        this.loginForm.reset();
        if (result != null) {
          this.configService.setByuiLeader(result);
          if (result.unitType === UnitType.Stake) {
            this.subscription = this.churchUnitsService
              .getCampusStakeDetails(result.unitId)
              .subscribe(stake => {
                if (stake != null) {
                  this.userService.setProxyStake(stake);
                  this.router.navigate(['leader/stake']);
                }
              });
          } else if (result.unitType === UnitType.Ward) {
            this.subscription = this.wardService
              .getCampusWardById(result.unitId)
              .subscribe(w => {
                this.userService.setProxyWard(w);
                this.router.navigate(['leader/ward']);
              });
          }
        }
      },
      () => {
        this.validating = false;
        this.errorResults = true;
        this.loginForm.reset();
      }
    );
  }
}
